import { render, staticRenderFns } from "./add-cart.vue?vue&type=template&id=107a3964&scoped=true"
import script from "./add-cart.vue?vue&type=script&lang=js"
export * from "./add-cart.vue?vue&type=script&lang=js"
import style0 from "./add-cart.vue?vue&type=style&index=0&id=107a3964&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107a3964",
  null
  
)

export default component.exports